import {ButtonPulse} from "./Button";
import {IFocusableRect} from "./Focusable";

export class SplashPlayButton extends ButtonPulse implements IFocusableRect {
}
